import clsx from "clsx";
import { Link } from "react-router-dom";
import { Icon } from "../../../../../../components";
import { getNtiUrl } from "../../../header/utils";

import styles from "./nti-link.module.scss";

type Props = {
  className?: string;
  fileName: string;
  proposedFileName?: string;
};

const NtiLink = ({ className, fileName, proposedFileName }: Props) => {
  const ntiUrl = getNtiUrl(fileName, proposedFileName);

  if (!ntiUrl) return null;

  return (
    <Link
      to={ntiUrl}
      className={clsx(styles.container, className)}
      data-testid="network_threat_intelligence_link"
    >
      <Icon className={styles.icon} name="open-in-new" />
      <span className={styles.label}>View Network Page</span>
    </Link>
  );
};

export default NtiLink;
